import { type ReactElement, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { usePostHog } from "../../common/posthog";
import { useAuth } from "./AuthContext";

interface ProtectedRouteProps {
  children: ReactElement;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { session, isLoading, tenantId } = useAuth();
  const location = useLocation();
  const posthog = usePostHog();

  // Track authentication state
  useEffect(() => {
    if (!isLoading) {
      if (session && tenantId) {
        // User is authenticated
        posthog.capture("auth_state", {
          state: "authenticated",
          has_tenant: Boolean(tenantId)
        });
      } else {
        // User is not authenticated
        posthog.capture("auth_state", {
          state: "unauthenticated",
          redirected_from: location.pathname
        });
      }
    }
  }, [isLoading, session, tenantId, location.pathname, posthog]);

  if (isLoading) {
    // TODO: Add a loading spinner component
    return null;
  }

  if (!session || !tenantId) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
